module.exports = __webpack_public_path__ + "img/edit.a50ea6d9.svg";